export default {
  exportDataTip: '请选择需要导出的数据',
  saledFeedback: '售后反馈',
  cancelPay: '取消支付',
  cancelReason: '取消原因',
  merchantRemark: '商品备注',
  fanhui: '返回',
  orderNo: '订单编号',
  unreply: '未回复',
  replied: '已回复',
  apply: '申请',
  badImg: '不良图片',
  applyDetail: '申请详情',
  replyDate: '回复日期',
  replyContent: '回复内容',
  orderMsg: '订单消息',
  otherMsg: '其他消息',
  clickUpload: '点击上传',
  uploadRefreshTip: '请等待所有图片上传成功或出现了网络问题，请刷新页面重新上传',
  uploadNumberTip: '最多可上传4张图片',
  uploadNumberTip9: '最多可上传9张图片',
  // 导出的模版
  addTemplate01: '报 价 单',
  addTemplate02: '收件人',
  addTemplate03: '主题',
  addTemplate04: '下载',
  addTemplate05: '报价日期',
  addTemplate06: '报价编号',
  addTemplate07: '【发行方】',
  addTemplate08: '邮编',
  addTemplate09: '负责人',
  addTemplate10: '报价总额（请款金额）',
  addTemplate11: '明细汇总',
  addTemplate12: '明细',
  addTemplate13: '商品图片',
  addTemplate14: '商品名称',
  addTemplate15: '尺寸',
  addTemplate16: '【备注・注意事项】',
  addTemplate17: '报价单_',
  addTemplate18: '总价',
  addTemplate19: '支付状态',
  addTemplate20: '已支付',
  addTemplate21: '已取消',
  addTemplate22: '是否确定支付？',
  addTemplate23: '是否确定取消？',
  addTemplate24: '未处理',
  addTemplate25: '仅供参考',
  addTemplate26: '付款待审核',
  addTemplate27: '最低充值金额为',
  addTemplate28: '这是关于进口代理和采购业务的明细账，包括商品费、中国国内运费、代理手续费和检品费。',
  remarkTemplate26: '上述金额按1 元＝{rate} 日元的汇率换算得出。',
  remarkTemplate27: '国际运费及关税未包含在本报价单内，商品送达后将按实际费用进行结算。',
  remarkTemplate28: '手续费按（商品金额＋中国国内运费）×{rate}% 的公式计算得出。',
  itemCost: '商品金额',
  domesticFreight: '中国国内运费',
  formulaStart: '手续费按（',
  formulaMiddle: '）×{rate}%',
  formulaFixed: ' + {fee}元',
  formulaEnd: ' 的公式计算得出。',
  priceRange: '{start}~{end}（元） ',
  priceRangeEndless: '价格 > {start}（元） ',
  addTemplate29: '有效期：自本报价单出具之日起 1 周',
};
